import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LinkAccountSelection from './Component';
import actions from './actions';
import selectors from './selectors';
import accountIntentSummarySelectors from '../../components/AccountLinkIntentSummary/selectors';

const mapStateToProps: any = createSelector(
  selectors.selectAccounts,
  selectors.selectSelectedAccount,
  accountIntentSummarySelectors.selectAccountIntent,
  (accounts, selectedAccount, accountIntent) => ({
    accounts,
    selectedAccount,
    accountIntent,
  })
);

const mapDispatchToProps: any = (dispatch: any) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccountSelection);
